import { render, staticRenderFns } from "./ExplanatoryFields.vue?vue&type=template&id=5837c5f4&scoped=true"
import script from "./ExplanatoryFields.vue?vue&type=script&lang=js"
export * from "./ExplanatoryFields.vue?vue&type=script&lang=js"
import style0 from "./ExplanatoryFields.vue?vue&type=style&index=0&id=5837c5f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837c5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5837c5f4')) {
      api.createRecord('5837c5f4', component.options)
    } else {
      api.reload('5837c5f4', component.options)
    }
    module.hot.accept("./ExplanatoryFields.vue?vue&type=template&id=5837c5f4&scoped=true", function () {
      api.rerender('5837c5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ExplanatoryFields.vue"
export default component.exports